import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="icp-switcher"
export default class extends Controller {
  static targets = ["form", "select", "mainForm"]

  switchTab() {
    const selectedSection = this.selectTarget.value
    
    // First, save the current form data if there's a main form
    if (this.hasMainFormTarget) {
      const mainForm = this.mainFormTarget
      const formData = new FormData(mainForm)
      
      // Add the new section value to the main form data
      formData.set('tab', selectedSection)
      
      // Submit the main form to save current data and switch sections
      const submitUrl = mainForm.action
      
      fetch(submitUrl, {
        method: 'PATCH',
        body: formData,
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
          'Accept': 'text/vnd.turbo-stream.html'
        }
      }).then(response => {
        if (response.ok) {
          return response.text()
        }
        throw new Error('Network response was not ok')
      }).then(html => {
        // Process the turbo stream response to update the configuration section
        Turbo.renderStreamMessage(html)
      }).catch(error => {
        console.error('Error saving form data and switching section:', error)
        // Fall back to just switching sections without saving
        this.switchSectionOnly(selectedSection)
      })
    } else {
      // No main form to save, just switch sections
      this.switchSectionOnly(selectedSection)
    }
  }

  switchSectionOnly(selectedSection) {
    // Update the dropdown form's hidden field and submit to switch sections
    const dropdownForm = this.formTarget
    const stepField = dropdownForm.querySelector('input[name="step"]')
    const tabField = dropdownForm.querySelector('select[name="tab"]')
    
    if (stepField) stepField.value = 'configure_icp'
    if (tabField) tabField.value = selectedSection
    
    // Submit the dropdown form to navigate to the new section
    dropdownForm.requestSubmit()
  }
}
